export default {
  "heading1": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "@media (min-width: 700px)": {
      "fontSize": "32px",
      "letterSpacing": "-0.02em"
    },
    "@media (max-width: 700px)": {
      "fontSize": "26px",
      "letterSpacing": "0"
    },
    "lineHeight": "1.25"
  },
  "heading2": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "@media (min-width: 700px)": {
      "fontSize": "28px"
    },
    "@media (max-width: 700px)": {
      "fontSize": "24px"
    },
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "heading3": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "@media (min-width: 700px)": {
      "fontSize": "24px"
    },
    "@media (max-width: 700px)": {
      "fontSize": "20px"
    },
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "heading4": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "@media (min-width: 700px)": {
      "fontSize": "20px"
    },
    "@media (max-width: 700px)": {
      "fontSize": "18px"
    },
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "heading5": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "@media (min-width: 700px)": {
      "fontSize": "16px"
    },
    "@media (max-width: 700px)": {
      "fontSize": "15px"
    },
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "heading6": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "fontSize": "14px",
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "headingXLarge": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "fontSize": "64px",
    "lineHeight": "1.25",
    "letterSpacing": "-0.02em"
  },
  "headingLarge": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "fontSize": "48px",
    "lineHeight": "1.25",
    "letterSpacing": "-0.02em"
  },
  "headingMedium": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": "Bold",
    "fontSize": "40px",
    "lineHeight": "1.25",
    "letterSpacing": "-0.02em"
  },
  "uiTextDefault": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": 500,
    "fontSize": "16px",
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "uiTextSmall": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": 500,
    "fontSize": "14px",
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "uiTextTiny": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": 500,
    "fontSize": "13px",
    "lineHeight": "1.25",
    "letterSpacing": "0"
  },
  "paragraphDefault": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": 500,
    "fontSize": "16px",
    "lineHeight": "1.5",
    "letterSpacing": "0",
    "textAlign": "left"
  },
  "paragraphSmall": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": 500,
    "fontSize": "14px",
    "lineHeight": "1.5",
    "letterSpacing": "0",
    "textAlign": "left"
  },
  "paragraphTiny": {
    "fontFamily": "\"Sharp Sans\", Helvetica, Arial, \"Trebuchet MS\", sans-serif",
    "fontWeight": 500,
    "fontSize": "13px",
    "lineHeight": "1.5",
    "letterSpacing": "0",
    "textAlign": "left"
  }
}
